/**
 * @var matchNonDigits
 * @type {RegExp}
 * @access private
 * @desc Regular expression used to match non digits.
 */
const matchNonDigits = /[^0-9]/g;

/**
 * @function scrubPhoneNumber
 * @desc scrubPhoneNumber non digits from phone number.
 *
 * @param {String} phoneNumber - the phone number.
 * @returns {String} number - formatted phone number.
 */
const scrubPhoneNumber = (phoneNumber: string = ''): string | null => {
  if (phoneNumber === '') return null;
  return phoneNumber.replace(matchNonDigits, '');
};

export default scrubPhoneNumber;
